@if (apiService.isStarted) {
	@if (apiService.isUserLoggedIn) {
		<app-menu />
	}
	<div [class.router-cont]="apiService.isUserLoggedIn">
		<router-outlet />
	</div>
	@if (apiService.isUserLoggedIn) {
		<app-footer />
	}
} @else {
	<div
		class="overlay-spinner"
		spin
	></div>
}
<!-- end of normal presentation -->
<app-toast />
<app-toast-download />
<app-misc-modals />
<ng-template #viewContainerRef></ng-template>
<!--<app-browser-tab-error />-->

@if (store.timeToRefreshMessage) {
	<div class="refresh">
		<app-icon
			icon="close"
			pointer
			(click)="store.timeToRefreshMessage = false"
		/>
		{{ "time_to_refresh" | langVal }}
	</div>
}

@if (hasHelp) {
	<div
		class="fixed-corner help-btn"
		(click)="isErrorOpen = true"
		titleLang="report_problem"
	>
		<p>?</p>
	</div>
	@if (isErrorOpen) {
		<app-modal-wrap
			(onClose)="isErrorOpen = false"
			modalWrapperClass="modal-650"
			title="how_can_we_help"
		>
			<app-error (onClose)="isErrorOpen = false" />
		</app-modal-wrap>
	}
}
@if (networkOffline) {
	<div class="network-offline">{{ "network_error" | langVal }}</div>
}
<!-- @if(!apiService.isUserLoggedIn){
  <div class="fixed-corner app-lang-select">
   <select (change)="langChanged()" [(ngModel)]="lang.langCode">
     <option value="iw">עברית</option>
     <option value="en">English</option>
   </select>
  </div>
} -->

<!-- @if(!hasApprovedCookies){
  <div class="approve-cookies">
    <div>Please approve cookies</div>
    <button (click)="approveCookies()">🐱</button>
  </div>
} -->
